import { render, staticRenderFns } from "./contentdetails.vue?vue&type=template&id=38da9750"
import script from "./contentdetails.vue?vue&type=script&lang=js"
export * from "./contentdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports